<template>
  <div>
    <div class="flex justify-between mb-2">
      <h3 class="font-semibold">
        {{ title }}
      </h3>
    </div>
    <div class="bg-white shadow rounded-lg p-4 relative">
      <div
        v-if="loading"
        class="p-10">
        <app-spinner />
      </div>
      <div
        v-for="(value, key) in data"
        v-else
        :key="key"
        class="flex justify-between">
        <span>{{ key }}</span>
        <span class="text-theme whitespace-nowrap text-ellipsis overflow-hidden pl-1">{{ value }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import AppSpinner from './AppSpinner.vue';

  export default {
    components: {
      AppSpinner,
    },
    props: {
      title: {
        type: String,
        required: true,
      },
      loading: {
        type: Boolean,
        default: true,
      },
      data: {
        type: Object,
        required: true,
      },
    },
  };
</script>
